import React from "react";

const Loading = () => (
  <div className="spinner">
    <div>
      <img src="/logo.png" alt="Loading" width="200" height="40" />
      <div className="loading"></div>
    </div>
  </div>
);

export default Loading;
